module.exports = __webpack_public_path__ + "static/media/v15.af24b4d5.mp4";